<template>
    <div class="page-classReport">
      <!--头部-->
      <knowledge-head :basicInfo='basicInfo' :classType="classType"
      @changeClassByData="changeClassById"/>
      <!--内容-->
      <div class="classReport__content">
        <tabs  @change="onTabChange" :active="activeId"/>
        <knowledge-detail v-show="activeId == 0"
          :basicInfo="basicInfo"
          :completed="completed"
          :incomplete="incomplete"
          :changeInfo="changeClassColumn"
          ref= "knowledgeDetails"/>
        <student-detail v-show="activeId == 1" ref="studentDetail"
        :studentData="studentData" :spreadData="spreadData"
         @change-data="onChangeData" :changeData="changeClassColumn"/>
        <common-wrong v-show="activeId == 2"
        :basicInfo="basicInfo"
        :wrongData="wrongData"/>
      </div>
    </div>
</template>

<script>
import Tabs from '@/components/tabs.vue';
import KnowledgeHead from './components/knowledge-head.vue';
import KnowledgeDetail from './components/knowledge-detail.vue';
import StudentDetail from './components/student-detail.vue';
import CommonWrong from './components/common-wrong.vue';
import {
  getClassReport, commonWrong,
  getCompletionStatusList, getStudentScoreList,

} from '../../api/pt';

const CLASS_TYPE = 1; // 1为班级报告 2为班级对比报告
export default {
  name: 'ClassReportPage',
  components: {
    Tabs,
    KnowledgeDetail,
    KnowledgeHead,
    StudentDetail,
    CommonWrong,
  },
  data() {
    return {
      classType: CLASS_TYPE,
      wrongData: [], // 错题列表
      studentData: [], // 学生列表
      spreadData: [], // 学生分布列表
      activeId: 0,
      isFirstWrong: true,
      isFirstStudent: true,
      basicInfo: {
        class_id: '',
        class_name: '',
        subject_name: '',
        textbook_name: '',
        test_name: '',
        evaluate_name: '',
        total_stu: '',
        finish_stu: '',
        avg_ability: '',
        avg_right_rate: '',
        avg_cost_time: '',
        score_distribution: [],
        code_list: [],
      },
      changeClassColumn: {}, // 记录变更后的值
      completed: [], // 已完成人数
      incomplete: [], // 未完成人数
    };
  },
  methods: {
    changeClassById(data) {
      // console.log('class-report', data);
      this.isFirstWrong = true;
      this.isFirstStudent = true;
      this.activeId = 0;
      this.changeClassColumn = data;
      // 切换后重制完成情况
      this.$refs.knowledgeDetails.$children[0].activeIndex = 'one';
      // 切换后清空学生完成情况搜索名称
      this.$refs.studentDetail.searchName = '';
      this.$refs.knowledgeDetails.isChangeOneInterFace = true;
      this.$refs.knowledgeDetails.isChangeTwoInterFace = true;
      this.$refs.knowledgeDetails.isChangeThreeInterFace = true;
      this.$refs.knowledgeDetails.isChangeFourInterFace = true;
      this.$refs.knowledgeDetails.isChangeFiveInterFace = true;

      this.$refs.knowledgeDetails.knowledgeTypeList = [
        {
          num: 0,
          totalNum: '',
          typeName: '未掌握(0-19%)',
          typeDetail: '呈现劣势的知识点',
        },
        {
          num: 0,
          totalNum: '',
          typeName: '掌握较弱(20-39%)',
          typeDetail: '需要继续加强学习的知识点',
        },
        {
          num: 0,
          totalNum: '',
          typeName: '掌握一般(40-59%)',
          typeDetail: '需要进一步提升的知识点',
        },
        {
          num: 0,
          totalNum: '',
          typeName: '掌握较好(60-79%)',
          typeDetail: '需要加强拓展的知识点',
        },
        {
          num: 0,
          totalNum: '',
          typeName: '掌握熟练(80-100%)',
          typeDetail: '图层呈现优势的知识点',
        },
      ];
      // 切换后必须调用此接口
      this.getClassReport(this.changeClassColumn);
      this.getCompletionStatusList(this.changeClassColumn);
      this.getStudentScoreList('', this.changeClassColumn);
      this.commonWrong(this.changeClassColumn);
    },
    // 改变父组件值
    onChangeData(data) {
      this.studentData = data;
    },
    onTabChange(index) {
      this.activeId = index;
    },
    // 完成情况查看详细
    getCompletionStatusList(data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      // console.log('change后的值', data);
      return getCompletionStatusList({
        class_id: data.class_id ? data.class_id : classId,
        evaluate_id: data.evaluate_id ? data.evaluate_id : evaluateId,
        school_id: schoolId,
      }).then((res) => {
        if (res.code === 200) {
          this.completed = res.data.completed;
          this.incomplete = res.data.incomplete;
        }
      });
    },
    // 错题接口
    commonWrong(wrongData) {
      const { evaluateId, classId } = this.$route.query;
      return commonWrong({
        evaluate_id: wrongData.evaluate_id
          ? wrongData.evaluate_id : evaluateId,
        class_id: wrongData.class_id ? wrongData.class_id : classId,
      }).then(({ data }) => {
        this.wrongData = data;
        this.isFirstWrong = false;
      });
    },
    // 学生接口
    getStudentScoreList(value, data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      return getStudentScoreList({
        evaluate_id: data.evaluate_id
          ? data.evaluate_id : evaluateId,
        school_id: schoolId,
        class_id: data.class_id ? data.class_id : classId,
        name: value,
      }).then((res) => {
        if (res.code === 200) {
          this.studentData = res.data.stu_list.map((item) => item)
            .sort((a, b) => b.avg_ability - a.avg_ability) || [];
          this.spreadData = res.data.score_distribution || [];
          // 首次默认按倒叙排
          // this.studentData.sort(this.compareSort('avg_ability', ''));
          this.isFirstStudent = false;
        }
      });
    },
    getClassReport(data) {
      const { evaluateId, schoolId } = this.$route.query;
      return getClassReport({
        evaluate_id: data.evaluate_id ? data.evaluate_id : evaluateId,
        school_id: schoolId,
      }).then((res) => {
        if (res.code === 200) {
          this.basicInfo = res.data;
          // 首次默认按倒叙排
          this.basicInfo.code_list.sort(this.compareSort('avg_ability', 'ascending'));
        }
      });
    },
    // 排序处理
    compareSort(data, type) {
      return (a, b) => {
        const sortA = a[data];
        const sortB = b[data];
        if (type === 'ascending') {
          return sortA - sortB;
        }
        return sortB - sortA;
      };
    },

  },
  mounted() {

  },
  activated() {
    this.isFirstWrong = true;
    this.isFirstStudent = true;
    this.activeId = 0;
    this.changeClassColumn = {};
    this.getClassReport({});
    this.getCompletionStatusList({});
    this.getStudentScoreList('', {});
    this.commonWrong({});
  },
};
</script>

<style lang="scss" scoped>
.page-classReport{
  box-sizing: border-box;
  width:100%;
}
</style>
